import { createConsoleLogger } from "./console";
import { Logger } from "./models";

let _defaultLogger: Logger | null = null;
const _consoleFallbackByName = new Map<string, Logger>();

function resolveLogger(name?: string): Logger {
  if (_defaultLogger) {
    if (!name) {
      return _defaultLogger;
    }
    return _defaultLogger.child(name);
  }

  const key = name || "default";
  let cached = _consoleFallbackByName.get(key);
  if (!cached) {
    cached = createConsoleLogger(key);
    _consoleFallbackByName.set(key, cached);
  }
  return cached;
}

function createLazyLogger(name?: string): Logger {
  return {
    get context() {
      return resolveLogger(name).context;
    },
    addContext(entries: Record<string, unknown>) {
      resolveLogger(name).addContext(entries);
    },
    debug(msg, context?, error?) {
      resolveLogger(name).debug(msg, context, error);
    },
    info(msg, context?, error?) {
      resolveLogger(name).info(msg, context, error);
    },
    warn(msg, context?, error?) {
      resolveLogger(name).warn(msg, context, error);
    },
    error(msg, context?, error?) {
      resolveLogger(name).error(msg, context, error);
    },
    child(childName: string) {
      const childLoggerName = name ? `${name}.${childName}` : childName;
      return createLazyLogger(childLoggerName);
    },
  };
}

export function setDefaultLogger(logger: Logger) {
  _defaultLogger = logger;
}

/** Clears the configured default logger (tests only). */
export function resetDefaultLoggerForTests() {
  _defaultLogger = null;
  _consoleFallbackByName.clear();
}

export function defaultLogger(name?: string): Logger {
  return createLazyLogger(name);
}
